export const QueryParamKeys = {
  content: 's',
  spinTime: 't',
  colorScheme: 'c',
};

export const literaryNamesStr =
  'Sherlock Holmes\n' +
  'Elizabeth Bennet\n' +
  'Jay Gatsby\n' +
  'Hermione Granger\n' +
  'Atticus Finch\n' +
  'Huckleberry Finn\n' +
  'Jane Eyre\n' +
  'Frodo Baggins\n' +
  'Harry Potter\n' +
  'Katniss Everdeen\n';

export const yesOrNoStr = '✅ Yes\n❌ No\n';

export const trueOrFalseStr = '1️⃣ True\n0️⃣ False\n';

export const diceStr =
  '🎲 1\n' +
  '🎲🎲 2\n' +
  '🎲🎲🎲 3\n' +
  '🎲🎲🎲🎲 4\n' +
  '🎲🎲🎲🎲🎲 5\n' +
  '🎲🎲🎲🎲🎲🎲 6\n';

export const headOrTailsStr =
  '🪙 Heads\n' +
  '🪙 Tails\n' +
  '🪙 Heads\n' +
  '🪙 Tails\n' +
  '🪙 Heads\n' +
  '🪙 Tails\n' +
  '🪙 Heads\n' +
  '🪙 Tails\n' +
  '🪙 Heads\n' +
  '🪙 Tails\n';

export const deckOfCardsStr =
  '🂡 Ace of Spades ♠️\n' +
  '🂢 2 of Spades ♠️\n' +
  '🂣 3 of Spades ♠️\n' +
  '🂤 4 of Spades ♠️\n' +
  '🂥 5 of Spades ♠️\n' +
  '🂦 6 of Spades ♠️\n' +
  '🂧 7 of Spades ♠️\n' +
  '🂨 8 of Spades ♠️\n' +
  '🂩 9 of Spades ♠️\n' +
  '🂪 10 of Spades ♠️\n' +
  '🂫 Jack of Spades ♠️\n' +
  '🂬 Queen of Spades ♠️\n' +
  '🂭 King of Spades ♠️\n' +
  '🂱 Ace of Hearts ♥️\n' +
  '🂲 2 of Hearts ♥️\n' +
  '🂳 3 of Hearts ♥️\n' +
  '🂴 4 of Hearts ♥️\n' +
  '🂵 5 of Hearts ♥️\n' +
  '🂶 6 of Hearts ♥️\n' +
  '🂷 7 of Hearts ♥️\n' +
  '🂸 8 of Hearts ♥️\n' +
  '🂹 9 of Hearts ♥️\n' +
  '🂺 10 of Hearts ♥️\n' +
  '🂻 Jack of Hearts ♥️\n' +
  '🂼 Queen of Hearts ♥️\n' +
  '🂽 King of Hearts ♥️\n' +
  '🃁 Ace of Diamonds ♦️\na' +
  '🃂 2 of Diamonds ♦️\n' +
  '🃃 3 of Diamonds ♦️\n' +
  '🃄 4 of Diamonds ♦️\n' +
  '🃅 5 of Diamonds ♦️\n' +
  '🃆 6 of Diamonds ♦️\n' +
  '🃇 7 of Diamonds ♦️\n' +
  '🃈 8 of Diamonds ♦️\n' +
  '🃉 9 of Diamonds ♦️\n' +
  '🃊 10 of Diamonds ♦️\n' +
  '🃋 Jack of Diamonds ♦️\n' +
  '🃌 Queen of Diamonds ♦️\n' +
  '🃍 King of Diamonds ♦️\n' +
  '🃑 Ace of Clubs ♣️\n' +
  '🃒 2 of Clubs ♣️\n' +
  '🃓 3 of Clubs ♣️\n' +
  '🃔 4 of Clubs ♣️\n' +
  '🃕 5 of Clubs ♣️\n' +
  '🃖 6 of Clubs ♣️\n' +
  '🃗 7 of Clubs ♣️\n' +
  '🃘 8 of Clubs ♣️\n' +
  '🃙 9 of Clubs ♣️\n' +
  '🃚 10 of Clubs ♣️\n' +
  '🃛 Jack of Clubs ♣️\n' +
  '🃝 Queen of Clubs ♣️\n' +
  '🃞 King of Clubs ♣️\n';

export const sportsTeamsStr =
  '🏈 New England Patriots\n' +
  '🏈 Kansas City Chiefs\n' +
  '🏈 Buffalo Bills\n' +
  '🏈 Baltimore Ravens\n' +
  '🏈 Cleveland Browns\n' +
  '🏈 Pittsburgh Steelers\n' +
  '🏈 Tennessee Titans\n' +
  '🏈 Indianapolis Colts\n' +
  '🏈 Houston Texans\n' +
  '🏈 Jacksonville Jaguars\n' +
  '🏈 Miami Dolphins\n' +
  '🏈 New York Jets\n' +
  '🏈 Denver Broncos\n' +
  '🏈 Las Vegas Raiders\n' +
  '🏈 Los Angeles Chargers\n' +
  '🏈 Dallas Cowboys\n' +
  '🏈 Washington Football Team\n' +
  '🏈 New York Giants\n' +
  '🏈 Philadelphia Eagles\n' +
  '🏈 Green Bay Packers\n' +
  '🏈 Chicago Bears\n' +
  '🏈 Minnesota Vikings\n' +
  '🏈 Detroit Lions\n' +
  '🏈 Tampa Bay Buccaneers\n' +
  '🏈 New Orleans Saints\n' +
  '🏈 Carolina Panthers\n' +
  '🏈 Atlanta Falcons\n' +
  '🏈 Seattle Seahawks\n' +
  '🏈 Los Angeles Rams\n' +
  '🏈 San Francisco 49ers\n' +
  '🏈 Arizona Cardinals\n';

export const numbersStr =
  '1\n' +
  '2\n' +
  '3\n' +
  '4\n' +
  '5\n' +
  '6\n' +
  '7\n' +
  '8\n' +
  '9\n' +
  '10\n';

export const alphabetsStr =
  'A\n' +
  'B\n' +
  'C\n' +
  'D\n' +
  'E\n' +
  'F\n' +
  'G\n' +
  'H\n' +
  'I\n' +
  'J\n' +
  'K\n' +
  'L\n' +
  'M\n' +
  'N\n' +
  'O\n' +
  'P\n' +
  'Q\n' +
  'R\n' +
  'S\n' +
  'T\n' +
  'U\n' +
  'V\n' +
  'W\n' +
  'X\n' +
  'Y\n' +
  'Z\n';

export const dinnerOptionsStr =
  '🍝 Spaghetti Bolognese\n' +
  '🥗 Grilled Chicken Caesar Salad\n' +
  '🌮 Beef Tacos with Salsa and Guacamole\n' +
  '🥦 Vegetable Stir-Fry with Tofu\n' +
  '🐟 Baked Salmon with Asparagus\n' +
  '🍜 Chicken Alfredo Pasta\n' +
  '🍕 Margherita Pizza\n' +
  '🍤 Shrimp Scampi with Linguine\n' +
  '🍖 BBQ Pulled Pork Sandwiches\n' +
  '🥩 Beef and Broccoli Stir-Fry\n' +
  '🍛 Vegetable Curry with Rice\n' +
  '🍔 Classic Cheeseburger and Fries\n' +
  '🍝 Chicken Parmesan with Spaghetti\n' +
  '🍆 Vegetarian Lasagna\n' +
  '🥩 Grilled Steak with Mashed Potatoes and Green Beans\n';
